export const MODULATOR_DETAILS_CARD_FRENCH_LOCALE = {
  title: "Détails du modulateur",
  location: "Localisation",
  serialNumber: "Numéro de série",
  hardwareId: "ID Hardware",
  site: "Site",
  csId: "ID Cs",
  pilot: "Pilote",
  neuronId: "Neuron ID",
  type: "Type",
};
